import type { FC } from 'react';

import styles from './order-book-ico.module.scss';

export const OrderBookICO: FC = () => {
  return <div className={styles.root}></div>;
};
